module.exports = __webpack_public_path__ + "static/media/mm.95787e3a.svg";